"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _default = {
  "vedano-olona": {
    "a7640399": [{
      "hkey": "59929db9",
      "slug": "vedano-olona",
      "name": "Vedano Olona",
      "primary": true,
      "skipSearch": false
    }],
    "c-na-celidonia": [{
      "hkey": "59929db9",
      "slug": "vedano-olona",
      "name": "Vedano Olona",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "b306b658": [{
      "hkey": "e9f4199c",
      "slug": "centro",
      "name": "Centro",
      "primary": true,
      "skipSearch": false
    }],
    "c-na-ronco": [{
      "hkey": "e9f4199c",
      "slug": "centro",
      "name": "Centro",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 10,
      "slugLevelParent": "vedano-olona"
    }],
    "80fc0302": [{
      "hkey": "59929db9",
      "slug": "vedano-olona",
      "name": "Vedano Olona",
      "primary": true,
      "skipSearch": false
    }],
    "case-popolari": [{
      "hkey": "59929db9",
      "slug": "vedano-olona",
      "name": "Vedano Olona",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "bd096ad5": [{
      "hkey": "7df670c1",
      "slug": "campagna",
      "name": "Campagna",
      "primary": true,
      "skipSearch": false
    }],
    "fondo-campagna": [{
      "hkey": "7df670c1",
      "slug": "campagna",
      "name": "Campagna",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 10,
      "slugLevelParent": null
    }],
    "bf2d42f3": [{
      "hkey": "59929db9",
      "slug": "vedano-olona",
      "name": "Vedano Olona",
      "primary": true,
      "skipSearch": false
    }],
    "pianasca": [{
      "hkey": "59929db9",
      "slug": "vedano-olona",
      "name": "Vedano Olona",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }]
  }
};
exports["default"] = _default;